const defaultTitle = 'Terriqon - Field Data Collection Platform'
const defaultDescription = 'A comprehensive platform to collect, manage, and analyze field data both online and offline.'

const metaData = {
  '/login': {
    title: 'Login | Terriqon - Field Data Collection Platform',
    description: 'Access your Terriqon account to manage forms, collect field data offline, and streamline field workflows.',
  },
  '/forgot-password': {
    title: 'Forgot Password | Terriqon',
    description: 'Forgot your password? Reset it here to regain access to your Terriqon account.',
  },
  '/reset-password': {
    title: 'Reset Password | Terriqon',
    description: 'Create a new password to regain access to your Terriqon account.',
  },
  '/set-password': {
    title: 'Set Password | Terriqon',
    description: 'Set up your secure password to activate your Terriqon account.',
  },
  '/dashboard': {
    title: 'Dashboard | Terriqon - Overview',
    description: 'Get a complete overview of your forms and field data insights in your Terriqon powerful dashboard.',
  },
  '/forms': {
    title: 'Forms | Terriqon - Manage Forms',
    description: 'Create, manage, and organize forms with ease. Our platform simplifies data collection for field teams.',
  },
  '/sync': {
    title: 'Sync Status | Terriqon - Data Upload & Updates',
    description: 'Check the status of your offline-to-online form syncs and ensure data is always up to date.',
  },
  '/chat': {
    title: 'Chat Support | Terriqon',
    description: 'Connect with admin support for real-time assistance and query resolution.',
  },
  '/settings': {
    title: 'Settings | Terriqon - Customize Your Experience',
    description: 'Manage account settings, preferences, and form configurations.',
  },
  '/settings/theme': {
    title: 'App Theme | Terriqon',
    description: 'Customize the look and feel of your Terriqon application.',
  },
  '/profile': {
    title: 'My Profile | Terriqon - User Information',
    description: 'View and manage your profile details, account information, and user settings.',
  },
  '/profile/change-password': {
    title: 'Change Password | Terriqon',
    description: 'Update your account password securely.',
  },
  '/forms/completed': {
    title: 'Completed Forms | Terriqon - Field Data Reports',
    description: 'Review completed forms and access valuable field data insights.',
  },
  '/forms/all': {
    title: 'All Forms | Terriqon - Data Collection in Progress',
    description: 'Track all assigned forms and manage field data submissions.',
  },
  '/forms/data': {
    title: 'Submission Data | Terriqon',
    description: 'View list of collected data and submissions for your projects.',
  },
  '/about': {
    title: 'About Us | Terriqon',
    description: 'Learn more about the Terriqon platform and our mission for field data collection.',
  },
  '/help': {
    title: 'Help & Support | Terriqon',
    description: 'Find answers to common questions and get support for using the platform.',
  },
}

const dynamicMeta = [
  {
    path: /^\/forms\/data\/[^/]+$/,
    handler: (location) => {
      const isEdit = new URLSearchParams(location.search).get('edit') === 'true'
      if (isEdit) {
        return {
          title: 'Edit Form Data | Terriqon',
          description: 'Modify form questions and field data collection settings.',
        }
      }
      return {
        title: 'Form Details | Terriqon',
        description: 'View in-depth form details, responses, and analysis.',
      }
    }
  },
  {
    path: /^\/forms\/fill\/[^/]+$/,
    handler: () => ({
      title: 'Fill Form | Terriqon',
      description: 'Fill out the form for real-time and offline data collection.',
    })
  },
  {
    path: /^\/chat\/[^/]+$/,
    handler: () => ({
      title: 'Chat Conversation | Terriqon',
      description: 'View conversation details and messages.',
    })
  }
]

export const updateMetaTags = (location) => {
  let pageMeta = metaData[location.pathname]
  
  if (!pageMeta) {
    const dynamicRoute = dynamicMeta.find(route => route.path.test(location.pathname))
    if (dynamicRoute) {
      pageMeta = dynamicRoute.handler(location)
    }
  }

  const { title, description } = pageMeta || { title: defaultTitle, description: defaultDescription }

  document.title = title
  
  let descriptionTag = document.querySelector('meta[name="description"]')
  if (descriptionTag) {
    descriptionTag.setAttribute('content', description)
  } else {
    const newDescriptionTag = document.createElement('meta')
    newDescriptionTag.setAttribute('name', 'description')
    newDescriptionTag.setAttribute('content', description)
    document.head.appendChild(newDescriptionTag)
  }
}